import { render, staticRenderFns } from "./SyncStepItems.vue?vue&type=template&id=187f01aa"
import script from "./SyncStepItems.vue?vue&type=script&lang=js"
export * from "./SyncStepItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports